export default "__VITE_ASSET__B8smZ0QH__"